import Router from "@/helpers/router";

import {
  WHATS_NEW_AUDIENCES,
  WHATS_NEW_ICONS,
  WhatsNewEntryI,
} from "../lib/types";

const { LGA, ADMIN } = WHATS_NEW_AUDIENCES;

/**
 * Team → EOM month-end tools (C-16 S2 EOM improvements, GLE-8527): copy
 * last month's credits and COGS, and the AR/AP pay list. Its own card, not
 * the EOM switch-on card (`2026-11-eom.ts`), and dark until
 * `manage/me.features.eom` like it, inside the same window (to 2026-12-01),
 * so it shows from EOM's switch-on whenever that is; each LGA and Admin
 * sees it on two ET days (C16-D425).
 */
export const EOM_CLOSE_TOOLS_2026_11: WhatsNewEntryI = {
  id: "2026-11-eom-close-tools",
  feature: "eom",
  startsAt: "2026-11-01T04:00:00.000Z",
  endsAt: "2026-12-01T05:00:00.000Z",
  title: {
    [LGA]: "Two shortcuts for the month-end close",
    [ADMIN]: "Two shortcuts for the month-end close",
  },
  intro: {
    [LGA]:
      "Copy last month's credits and COGS into your month, and export who gets paid.",
    [ADMIN]:
      "Copy last month's credits and COGS into a workspace's month, and export who to pay.",
  },
  sections: [
    {
      id: "copy-lines",
      audiences: [LGA, ADMIN],
      icon: WHATS_NEW_ICONS.SPARKLES,
      title: "Copy from last month",
      items: [
        "Open a workspace's month: Credits and COGS → Copy from last month lists last month's lines.",
        "Tick the ones that recur, check each amount, and add them in one go.",
        "Lines already on this month start unticked. Add this month's evidence to each copied line.",
      ],
      link: { label: "Open EOM", href: Router.manageEom() },
    },
    {
      id: "pay-list",
      audiences: [LGA, ADMIN],
      icon: WHATS_NEW_ICONS.SCORE,
      title: "Export pay list",
      items: [
        "AR/AP → Export pay list: one row per payout or receivable, grouped by who, with reps' emails.",
        "It saves the rows the filter shows: Open is what's still to pay or collect.",
      ],
    },
  ],
};
